import ClearLocalStorageLibrary from "@paylands-frontend/libraries/dist/ClearLocalStorage";

export class ClearLocalStorage {
    clear(): void {
        const exclude = ["i18nextLng", "settings", "persist:root"];

        new ClearLocalStorageLibrary(exclude).clear();
    }
}
